(function () {
  // Adds an "Add to Wishlist" button to each cart line item (mini-cart drawer and /cart page),


  var WISHLIST_ICON_SVG =
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-icon="heart" focusable="false">' +
    '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  // ProductJson-{id}/OptionJson-{id} are keyed by product_id only, matching
  // snippets/twc-wishlistbutton.liquid 
  var buttonItemData = new WeakMap();

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function isRemoveTrigger(el) {
    if (el.tagName !== 'P' && el.tagName !== 'BUTTON') return false;
    if (el.textContent.trim() !== 'Remove') return false;
    var cls = el.className;
    return typeof cls === 'string' && cls.indexOf('text-grey-500') !== -1;
  }

  // Mini-cart drawer row layout (assets/section-cart-slideout.js)
  function findRowRootByClass(removeEl) {
    var el = removeEl.parentElement;
    for (var i = 0; i < 10 && el; i++) {
      var cls = el.className;
      if (typeof cls === 'string' && /(^|\s)relative(\s|$)/.test(cls) && /(^|\s)grid(\s|$)/.test(cls)) {
        return el;
      }
      el = el.parentElement;
    }
    return null;
  }

  // Cart page's line item (assets/section-cart-page.js) 
  function getCartPageListWrapper(container) {
    return container.querySelector('.flex.flex-col.divide-y');
  }

  function hasRemoveTrigger(rowEl) {
    var candidates = rowEl.querySelectorAll('p, button');
    for (var i = 0; i < candidates.length; i++) {
      if (isRemoveTrigger(candidates[i])) return true;
    }
    return false;
  }

  function collectRowRoots(container) {
    var listWrapper = getCartPageListWrapper(container);
    if (listWrapper) {
      var rows = [];
      for (var i = 0; i < listWrapper.children.length; i++) {
        var child = listWrapper.children[i];
        if (hasRemoveTrigger(child)) rows.push(child);
      }
      return rows;
    }

    var triggers = container.querySelectorAll('p, button');
    var roots = [];
    for (var j = 0; j < triggers.length; j++) {
      if (!isRemoveTrigger(triggers[j])) continue;
      var root = findRowRootByClass(triggers[j]);
      if (root && roots.indexOf(root) === -1) roots.push(root);
    }
    return roots;
  }

  function getMatchableItems(container, items) {
    if (!getCartPageListWrapper(container)) return items;
    return items.filter(function (item) {
      return !(item.properties && item.properties.isCartGift);
    });
  }

  function getOptionValues(item) {
    var optionsWithValues = Array.isArray(item.options_with_values) ? item.options_with_values : [];
    return optionsWithValues.map(function (o) {
      return o && o.value != null ? String(o.value) : null;
    });
  }

  function buildImageObject(url) {
    if (!url) return null;
    return { src: url, url: url, alt: null, width: null, height: null };
  }

  function buildProductJson(item) {
    var optionValues = getOptionValues(item);
    var optionsWithValues = Array.isArray(item.options_with_values) ? item.options_with_values : [];
    var image = buildImageObject(item.image);

    return {
      id: item.product_id,
      title: item.product_title || item.title,
      price: item.price,
      options: optionsWithValues.map(function (o) { return o && o.name; }).filter(Boolean),
      featured_image: image,
      images: image ? [image] : [],
      variants: [
        {
          id: item.variant_id || item.id,
          title: item.variant_title || item.title,
          price: item.price,
          available: true,
          featured_image: image,
          image_id: null,
          image: image,
          option1: optionValues[0] != null ? optionValues[0] : null,
          option2: optionValues[1] != null ? optionValues[1] : null,
          option3: optionValues[2] != null ? optionValues[2] : null
        }
      ]
    };
  }

  // Always (re)writes ProductJson-{id}/OptionJson-{id} to this item's own single-variant data
  function writeProductJsonTags(item) {
    var productId = item.product_id;

    var existingProduct = document.getElementById('ProductJson-' + productId);
    if (existingProduct) existingProduct.remove();
    var productScript = document.createElement('script');
    productScript.type = 'application/json';
    productScript.id = 'ProductJson-' + productId;
    productScript.textContent = JSON.stringify(buildProductJson(item));
    document.body.appendChild(productScript);

    var existingOption = document.getElementById('OptionJson-' + productId);
    if (existingOption) existingOption.remove();
    var optionScript = document.createElement('script');
    optionScript.type = 'application/json';
    optionScript.id = 'OptionJson-' + productId;
    optionScript.textContent = '[]';
    document.body.appendChild(optionScript);
  }

  function injectButton(rowRoot, item) {
    var productId = item.product_id;
    writeProductJsonTags(item);

    var optionValues = getOptionValues(item);
    var optionAttrs = optionValues.map(function (value, index) {
      return value != null ? ' data-option' + (index + 1) + '="' + escapeHtml(value) + '"' : '';
    }).join('');

    var wrapper = document.createElement('div');
    wrapper.className = 'osc-css wrapper-button-collection cart-line-item-wishlist';
    wrapper.style.cssText = 'position:absolute; top:1.159rem!important; right:0; z-index:2;';
    wrapper.innerHTML =
      '<button type="button" class="button-collection-wishlist button-' + productId + '" ' +
      'style="background:transparent; border:0; padding:4px; cursor:pointer; line-height:0;" ' +
      'data-product-id="' + productId + '" ' +
      'data-has-only-variant="true" ' +
      'data-product-title="' + escapeHtml(item.product_title || item.title) + '"' + optionAttrs + '>' +
      '<span class="button-icon">' + WISHLIST_ICON_SVG + '</span>' +
      '<span class="button-text"></span>' +
      '</button>';

    var computedPosition = window.getComputedStyle(rowRoot).position;
    if (computedPosition === 'static') rowRoot.style.position = 'relative';
    rowRoot.appendChild(wrapper);

    buttonItemData.set(wrapper.firstElementChild, item);
  }

  function processContainer(container, items, processedRows) {
    var rows = collectRowRoots(container).filter(function (row) {
      return !processedRows.has(row);
    });
    if (!rows.length) return false;

    var allRows = collectRowRoots(container);
    var matchableItems = getMatchableItems(container, items);

    if (allRows.length !== matchableItems.length) return false;

    var injectedAny = false;
    for (var i = 0; i < allRows.length; i++) {
      var row = allRows[i];
      if (processedRows.has(row)) continue;
      var item = matchableItems[i];
      if (!item) continue;
      injectButton(row, item);
      processedRows.add(row);
      injectedAny = true;
    }
    return injectedAny;
  }

  document.addEventListener('twc:ready', function () {
    var containers = [];
    var slideout = document.querySelector('cart-slideout');
    if (slideout) containers.push(slideout);
    var cartPage = document.querySelector('cart-page');
    if (cartPage) containers.push(cartPage);
    if (!containers.length) return;

    var processedRows = new WeakSet();
    var syncTimer;
    var isReinitializingWishlist = false;

    function sync() {
      if (isReinitializingWishlist) return;

      var hasUnprocessed = containers.some(function (container) {
        return collectRowRoots(container).some(function (row) {
          return !processedRows.has(row);
        });
      });
      if (!hasUnprocessed) return;

      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var items = cart.items || [];
          var injectedAny = false;
          containers.forEach(function (container) {
            if (processContainer(container, items, processedRows)) injectedAny = true;
          });

          if (injectedAny) {
            isReinitializingWishlist = true;
            if (window.theWishlist && typeof window.theWishlist.init === 'function') {
              window.theWishlist.init();
            }
            document.body.dispatchEvent(new CustomEvent('initTheWishlist'));
            setTimeout(function () {
              isReinitializingWishlist = false;
            }, 300);
          }
        })
        .catch(function () {});
    }

    function scheduleSync() {
      if (isReinitializingWishlist) return;
      clearTimeout(syncTimer);
      syncTimer = setTimeout(sync, 200);
    }

    // Only a real cart re-render (rows added/replaced) should trigger a sync. Our own injected
    // .wrapper-button-collection and theWishlist.init()'s in-place icon/text rewrites inside it
    // (from this file or twc-wishlist.js - each has its own local "reinitializing" flag, so
    // neither mutes the other's init()) also land here as childList mutations; reacting to
    // those kept re-running sync() -> fetch('/cart.js') nonstop and made the buttons blink.
    function isWishlistMutation(mutation) {
      var target = mutation.target;
      if (target instanceof Element && target.closest('.wrapper-button-collection')) return true;
      var nodes = Array.prototype.slice.call(mutation.addedNodes).concat(Array.prototype.slice.call(mutation.removedNodes));
      return nodes.length > 0 && nodes.every(function (n) {
        return !(n instanceof Element) || n.classList.contains('wrapper-button-collection');
      });
    }

    containers.forEach(function (container) {
      new MutationObserver(function (mutationsList) {
        if (isReinitializingWishlist) return;
        for (var i = 0; i < mutationsList.length; i++) {
          if (!isWishlistMutation(mutationsList[i])) {
            scheduleSync();
            return;
          }
        }
      }).observe(container, { childList: true, subtree: true });
    });

    document.addEventListener('shopify:cart:lines-update', function (event) {
      var promise = event && event.promise;
      if (promise && typeof promise.then === 'function') {
        promise.then(scheduleSync).catch(scheduleSync);
      } else {
        scheduleSync();
      }
    });

    scheduleSync();
  });

  document.addEventListener('twc:ready', function () {
    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      var button = event.target.closest('.cart-line-item-wishlist .button-collection-wishlist');
      if (!button) return;
      var item = buttonItemData.get(button);
      if (item) writeProductJsonTags(item);
    }, true);
  });

  document.addEventListener('twc:ready', function () {
    var pollTimer;

    function selectGroup(groups, optionValues, index) {
      if (index >= groups.length) return;
      var group = groups[index];
      var match = /^option(\d+)$/.exec(group.getAttribute('name') || '');
      var expectedValue = match ? optionValues[Number(match[1]) - 1] : null;

      if (expectedValue != null) {
        var input = Array.prototype.find.call(group.querySelectorAll('input'), function (candidate) {
          return candidate.value === expectedValue;
        });
        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      setTimeout(function () {
        var freshGroups = document.querySelectorAll('.variant-item-list[name^="option"]');
        selectGroup(Array.prototype.slice.call(freshGroups), optionValues, index + 1);
      }, 60);
    }

    function preSelectCartVariant(optionValues) {
      clearInterval(pollTimer);
      if (!optionValues.length) return;

      var attempts = 0;
      pollTimer = setInterval(function () {
        attempts += 1;
        var groups = document.querySelectorAll('.variant-item-list[name^="option"]');
        if (groups.length) {
          clearInterval(pollTimer);
          selectGroup(Array.prototype.slice.call(groups), optionValues, 0);
        } else if (attempts >= 15) {
          clearInterval(pollTimer);
        }
      }, 100);
    }

    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      var button = event.target.closest('.cart-line-item-wishlist .button-collection-wishlist');
      if (!button) return;

      var optionValues = [button.dataset.option1, button.dataset.option2, button.dataset.option3]
        .filter(function (value) { return value != null && value !== ''; });
      preSelectCartVariant(optionValues);
    });
  });
})();
